import { SimpleFullScreenPageWithAppBarAndTitle } from "components/pages/pages_with_outlet/SimpleFullScreenPageWithAppBarAndTitle";
import { InstrumentPage } from "../instruments/components/InstrumentPage";

//Todo fix types
export const ModulePage = ({ title }: any) => {
  return (
    <SimpleFullScreenPageWithAppBarAndTitle title={title} order={4}>
      <InstrumentPage />
    </SimpleFullScreenPageWithAppBarAndTitle>
  );
};
